"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HealthPass = void 0;

var HealthPass =
/** @class */
function () {
  function HealthPass() {}

  HealthPass.prototype.HealthPassScoreType = function () {
    return [{
      slug: 'green',
      name: 'Cleared',
      description: null,
      isCleared: true,
      isNotCleared: false,
      isPending: false,
      isUnknown: false
    }, {
      slug: 'red',
      name: 'Not Cleared',
      description: null,
      isCleared: false,
      isNotCleared: true,
      isPending: false,
      isUnknown: false
    }, {
      slug: 'amber',
      name: 'Pending',
      description: null,
      isCleared: false,
      isNotCleared: false,
      isPending: true,
      isUnknown: false
    }, {
      slug: 'unknown',
      name: 'Unknown',
      description: null,
      isCleared: false,
      isNotCleared: false,
      isPending: false,
      isUnknown: true
    }];
  };

  return HealthPass;
}();

exports.HealthPass = HealthPass;